import {
  Bot,
  Users,
  Globe,
  BarChart3,
  QrCode,
} from 'lucide-react'

// ============================================
// CONFIGURACIÓN DE COLORES (basada en logo)
// ============================================
export const COLORS = {
  primary: '#6B7C93',
  primaryDark: '#4A5568',
  primaryLight: '#8BA3BE',
  accent: '#6B7C93',
}

// ============================================
// DATOS: Carrusel de Dolores/Soluciones
// ============================================
export const PAIN_POINTS = [
  {
    question: '¿Tu competencia se ve más profesional que tú?',
    solution: 'Tu sitio web profesional listo en minutos',
    description: 'Proyecta imagen de agente top con tu propio sitio web y dominio personalizado.',
    icon: Globe,
    tool: 'Web Personal'
  },
  {
    question: '¿Tus propiedades se pierden en el feed de redes?',
    solution: 'Página dedicada + QR para cada propiedad',
    description: 'Cada propiedad con su propia landing page y código QR para flyers y espectaculares.',
    icon: QrCode,
    tool: 'Propiedades + QR'
  },
  {
    question: '¿Leads regados en WhatsApp, notas y Excel?',
    solution: 'CRM que centraliza todo tu negocio',
    description: 'Organiza contactos, da seguimiento y nunca pierdas un prospecto caliente.',
    icon: Users,
    tool: 'CRM Inmobiliario'
  },
  {
    question: '¿Te escriben a las 11pm y contestas al día siguiente?',
    solution: 'Agente IA que responde y filtra 24/7',
    description: 'Tu asistente virtual atiende, califica y te envía solo compradores reales.',
    icon: Bot,
    tool: 'Agente IA'
  },
  {
    question: '¿No sabes qué propiedades generan más interés?',
    solution: 'Analytics y métricas en tiempo real',
    description: 'Conoce visitas, interacciones y optimiza tu estrategia con datos reales.',
    icon: BarChart3,
    tool: 'Analytics'
  }
]

// ============================================
// DATOS: Testimonios
// ============================================

export const TESTIMONIALS = [
  {
    name: 'Mr. Javier López',
    role: 'Agente REMAX Sunset Eagle',
    location: 'Mazatlán, Sinaloa',
    quote: 'Incluyo mi website INNOVAGENT en cada publicación en redes sociales y mi "PROPIO YO" perfila por mí. Me envía alerta en tiempo real cuando eleva a LEAD CALIFICADO. Acabo de concluir video llamada con cliente nuevo de condo vista al mar. Es la herramienta definitiva.',
    rating: 5,
    image: 'https://raw.githubusercontent.com/ruxo-rod/files/main/MrJavier2.jpeg',
    website: 'https://mrjavierlopez.innovagent.tech'
  },
  {
    name: 'Ismael Rodríguez V.',
    role: 'Director de Agencia Orbe',
    location: 'Torreón Coahuila',
    quote: 'Implementamos InnovAgent en toda nuestra agencia. La confianza de nuestros agentes aumentó significativamente y la calidad de los leads mejoró porque el Agente IA pre-califica antes de contactarnos.',
    rating: 5,
    image: 'https://storage.googleapis.com/innoviagent-assets/avatars/c8fbdae5-0924-4f11-96a4-d086296164b1/avatar.png',
    website: 'https://inmobiliaria-orbe.innovagent.tech'
  },
  {
    name: 'Ing. Javier Mota Vazquez',
    role: 'Inmobiliaria ISSO',
    location: 'Cd. Victoria, Tams',
    quote: 'Antes tenía propiedades dispersas en redes sin seguimiento. Hoy tengo un sistema que trabaja por mí: páginas profesionales, respuestas automáticas y menos desgaste. Mi imagen frente a los clientes cambió totalmente.',
    rating: 5,
    image: 'https://raw.githubusercontent.com/ruxo-rod/files/main/Javier%20Mota.jpeg',
    website: 'https://javier-mota.innovagent.tech'
  }
]

// ============================================
// DATOS: Emails de contacto
// ============================================
export const EMAILS = {
  contacto: 'contacto@bdctech.com.mx',
  soporte: 'soporte@bdctech.com.mx',
  ventas: 'contacto@bdctech.com.mx',
}

// ============================================
// DATOS: Características/Features
// ============================================
export const FEATURES = [
  { icon: Globe, title: 'Tu Sitio Web Profesional', description: 'Subdominio personalizado con diseño premium. Tu marca, tu identidad, sin saber programar.', color: '#10B981' },
  { icon: 'Smartphone', title: 'Landing por Propiedad', description: 'Cada propiedad con su propia página profesional. Perfecta para compartir y dar seguimiento.', color: '#8B5CF6' },
  { icon: QrCode, title: 'QR Codes Inteligentes', description: 'Genera códigos QR de tu marca y cada propiedad. Ideal para letreros, flyers y espectaculares.', color: '#EF4444' },
  { icon: Bot, title: 'Agente IA 24/7', description: 'Tu asistente virtual que conoce tus propiedades, responde al instante y filtra curiosos.', color: '#6B7C93' },
  { icon: Users, title: 'CRM Inmobiliario', description: 'Gestiona leads, programa seguimientos y nunca pierdas un prospecto caliente.', color: '#F59E0B' },
  { icon: BarChart3, title: 'Analytics en Tiempo Real', description: 'Conoce qué propiedades generan más interés y de dónde vienen tus mejores leads.', color: '#EC4899' },
]

// ============================================
// DATOS: Planes de precios (LEGACY - usar pricing.ts para precios dinámicos)
// Se mantiene para compatibilidad, pero PricingSection.tsx usará pricing.ts
// ============================================
export const PRICING_PLANS = [
  {
    id: 'free',
    name: 'Prueba Gratuita',
    description: 'Para probar la plataforma',
    price: '$0',
    period: 'MXN/15 días',
    features: [
      'Webpage profesional con subdominio',
      'Landing page por propiedad',
      'Agente IA 24/7 calificando leads',
      '10 chats con IA/mes',
      '3 propiedades',
      '3 imágenes por propiedad',
      'CRM completo',
      'Analytics',
      'QR Codes',
      '4 templates profesionales'
    ],
    cta: 'Comenzar Gratis',
    popular: false,
    elite: false
  },
  {
    id: 'basico',
    name: 'Básico',
    description: 'Para agentes que inician',
    price: '$990',
    period: 'MXN/mes',
    features: [
      'Webpage profesional con subdominio',
      'Landing page por propiedad',
      'Agente IA 24/7 calificando leads',
      '80 chats con IA/mes',
      '10 propiedades',
      '5 imágenes por propiedad',
      '5 Documentos entrenamiento IA',
      '10 MB almacenaje',
      'CRM completo',
      'Analytics',
      'QR Codes',
      '4 templates profesionales',
      'Soporte por email'
    ],
    cta: 'Elegir Básico',
    popular: false,
    elite: false
  },
  {
    id: 'pro',
    name: 'Pro',
    description: 'Para agentes profesionales',
    price: '$1,749',
    period: 'MXN/mes',
    features: [
      'Webpage profesional con subdominio',
      'Landing page por propiedad',
      'Agente IA 24/7 calificando leads',
      '250 chats con IA/mes',
      '50 propiedades',
      '10 imágenes por propiedad',
      '10 Documentos entrenamiento IA',
      '50 MB almacenaje',
      'CRM completo',
      'Analytics avanzados',
      'QR Codes',
      '4 templates profesionales',
      'Soporte por email'
    ],
    cta: 'Elegir Pro',
    popular: true,
    elite: false
  },
  {
    id: 'elite',
    name: 'Elite',
    description: 'Para equipos y agencias',
    price: 'Contactar',
    period: '',
    features: [
      'Webpage profesional con subdominio',
      'Landing page por propiedad',
      'Chats ilimitados',
      'Propiedades ilimitadas',
      'Agente IA 24/7 calificando leads',
      '25 imágenes por propiedad',
      '50 Documentos entrenamiento IA',
      '200 MB almacenaje',
      'CRM completo',
      'Analytics avanzados',
      'QR Codes',
      '4 templates + personalizados',
      'Soporte prioritario'
    ],
    cta: 'Contactar Ventas',
    popular: false,
    elite: true
  }
]

// ============================================
// DATOS: Pasos "Cómo Funciona"
// ============================================
export const HOW_IT_WORKS_STEPS = [
  { step: '1', title: 'Crea tu Cuenta', description: 'Regístrate en 2 minutos. Tu sitio web se genera automáticamente.' },
  { step: '2', title: 'Personaliza y Sube', description: 'Agrega tus propiedades, personaliza tu perfil y entrena a tu Agente IA.' },
  { step: '3', title: 'Recibe Leads', description: 'Comparte tu sitio, tu IA trabaja 24/7 y tú solo cierras ventas.' },
]
